// Decorative marquee of greetings drifting behind the banner content.
export const BANNER_GREETINGS = [
  'Hello',
  'Hola',
  'Bonjour',
  '你好',
  'こんにちは',
  'Hallo',
  'Ciao',
  'Olá',
  '안녕하세요',
  'مرحبا',
  'नमस्ते',
  'Hej',
  'Merhaba',
] as const;

// CTA variations rotated by useLeadSurvey().nextBannerCta().
export const BANNER_CTA_VARIATIONS = [
  {
    title: 'Integrate Rask into your workflow hassle-free',
    cta: 'I need integration',
    subtitle: 'Book a 1:1 demo — we’ll take it from there.',
  },
  {
    title: 'Producing serious volume?',
    cta: 'Cut costs and effort',
    subtitle: 'Book a 1:1 demo — we’ll build your localization plan.',
  },
  {
    title: 'Want to delegate your localization work to us?',
    cta: 'Let us handle it',
    subtitle: 'See exactly how on a 30-minute call with our team.',
  },
] as const;
